/**
 * Count schedule assignments by kind, optionally for one trade. Assignments pointing at
 * a trade no longer on the skill map are ignored, as the cost engine ignores them.
 *
 * @param {object[]} assignments
 * @param {{ trades: Object<string, string>, tradeId?: string }} options
 * @returns {{ folder: number, schedule: number, task: number }}
 */
export function countAssignmentsByKind(assignments, { trades, tradeId }) {
    const counts = { folder: 0, schedule: 0, task: 0 }
    for (const assignment of assignments || []) {
        if (!trades[assignment.tradeId]) continue
        if (tradeId && assignment.tradeId !== tradeId) continue
        if (assignment.kind in counts) counts[assignment.kind]++
    }
    return counts
}

/**
 * "2 folders, 12 schedules, 1 task", or "" when there are none.
 * @param {{ folder: number, schedule: number, task: number }} counts
 */
export function describeAssignmentCounts({ folder, schedule, task }) {
    const parts = []
    if (folder) parts.push(`${folder} ${"folder".pluralize(folder)}`)
    if (schedule) parts.push(`${schedule} ${"schedule".pluralize(schedule)}`)
    if (task) parts.push(`${task} ${"task".pluralize(task)}`)
    return parts.join(", ")
}
